import { VideoDto } from './video.model';
import { Video } from '@lyceo/lyceo-pupil-app/practise/util-models';

export function mapVideo(videoDto: VideoDto): Video {
  return {
    id: videoDto.id,
    url: videoDto.url,
    position: videoDto.position,
  };
}
